import { ILendersResponse } from '../interfaces';
import { GlobalInputsModel, IGlobalInputs } from './GlobalInputsModel';
import { DealModel, IDeal } from './DealModel';
import { EligibleLender, IEligibleLender } from './EligibleLenderModel';
import { IIneligibleLender, IneligibleLenderModel } from './IneligibleLender';

export class DealCalculatorModel implements Partial<ILendersResponse> {
  globalInputs: Partial<IGlobalInputs> = new GlobalInputsModel();
  deal: IDeal = new DealModel();
  eligibleLenders: IEligibleLender[] = [];
  ineligibleLender: IIneligibleLender[] = [];

  constructor(data?: ILendersResponse) {
    if (data) {
      this.globalInputs = new GlobalInputsModel(data?.globalInputs);
      this.deal = data?.deal || new DealModel();
      this.eligibleLenders = data?.eligibleLenders?.map((i) => new EligibleLender(i) as IEligibleLender) || [];
      this.ineligibleLender =
        data?.ineligibleLender?.map((i) => new IneligibleLenderModel(i) as IIneligibleLender) || [];
    }
  }
}
